import { GlobalStyle } from ".."
import { Assets } from "../styles/assets"
import { LoadStyle, LoadVariant } from "./style"

interface LoadProps {
    variant?: LoadVariant;
}

export const Load = ({ variant = "default" }: LoadProps) => {
    return (
        <>
            <GlobalStyle />
            <LoadStyle $variant={variant}>
                <img width="70px" height="70px" src={Assets.loadingWhite} alt="Loading" />
            </LoadStyle>
        </>
    )
}